import React from 'react';

import { JobsContainer, JobsH1, JobsSub} from './JobsElements';

const Jobs = () => { 
  return (
    <JobsContainer id="jobs">
        <JobsH1> Roles</JobsH1>
        <JobsSub> Contact us and we will be sure to get back to you with our available roles.</JobsSub>
    </JobsContainer>
  )
}

export default Jobs;
